import { Observable } from 'rxjs';
import { SelectData } from '@shared/models/select-input.model';

/**
 * Arquivo já salvo no servidor, exibido no input de arquivo (FormInputType.FILE)
 * junto dos arquivos recém-selecionados. Estruturalmente compatível com
 * `ExistingFile` do FileUploaderComponent (definido lá para evitar dependência
 * circular model → component).
 */
export interface FormInputExistingFile {
  name: string;
  fileId?: number;
  fileGuid?: string;
  size?: number;
}

export enum FormInputType {
  TEXT = 'TEXT',
  SELECT = 'SELECT',
  RADIO = 'RADIO',
  DATE = 'DATE',
  CHECKBOX = 'CHECKBOX',
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  CURRENCY = 'CURRENCY',
  DIVISOR = 'DIVISOR',
  SUBDIVISOR = 'SUBDIVISOR',
  NUMBER = 'NUMBER',
  CEP = 'CEP',
  CPF_CNPJ = 'CPF_CNPJ',
  EMAIL_LIST = 'EMAIL_LIST',
  FILE = 'FILE',
  MONTH = 'MONTH',
  PASSWORD = 'PASSWORD',
}

export interface FormInput {
  name: string;
  type: FormInputType;
  formControlName?: string;
  id?: string;
  value?: unknown;
  required?: boolean;
  select?: Observable<SelectData[]>;
  mask?: string;
  prefix?: string;
  radios?: { name: string; value: unknown; checked?: boolean }[];
  isEmail?: boolean;
  class?: string;
  minDate?: Date;
  maxDate?: Date;
  weekFilter?: boolean;
  multiple?: boolean;
  /** Tipos aceitos no input de arquivo (ex.: ['.png', '.jpg', '.pdf']). Só para FormInputType.FILE. */
  accept?: string[];
  /** Arquivos já salvos no servidor, exibidos no input (com download/remoção). Só para FormInputType.FILE. */
  existingFiles?: FormInputExistingFile[];
  /** Callback ao clicar em download de um arquivo já salvo. Só para FormInputType.FILE. */
  onExistingFileDownload?: (file: FormInputExistingFile) => void;
  /** Callback ao remover um arquivo já salvo (para não reenviá-lo no save). Só para FormInputType.FILE. */
  onExistingFileRemove?: (file: FormInputExistingFile) => void;
  hint?: string;
  errorMessage?: string;
  autocomplete?: string;
  viewMode?: 'month' | 'year' | 'multi-year';
  headerActionControl?: any;
  headerActionLabel?: string;
  cardStyle?: boolean;
  radioInline?: boolean;
}
